import { CHECK_SCREENING_CL, CHECK_SCREENING_CL_SUCCESS, GET_COLLECTION_CENTER_BY_LEVEL_CL, GET_COLLECTION_CENTER_BY_LEVEL_CL_SUCCESS, GET_DECLINE_REASONS_CL, GET_DECLINE_REASONS_CL_SUCCESS, GET_GEOLOCATIONS_SUCCESS, POST_ADHESION_CL, POST_DECLINE_CL, RESET_SCREENING_COLON_RETTO_STATE } from "./actionsType"

export const checkScreeningCLAction = () => ({
    type: CHECK_SCREENING_CL,
})

export const checkScreeningCLActionSuccess = (payload) => ({
    type: CHECK_SCREENING_CL_SUCCESS,
    payload
})

export const postDeclineCLAction = () => ({
    type: POST_DECLINE_CL,
})

export const postAdhesionCLAction = (payload) => ({
    type: POST_ADHESION_CL,
    payload
})

export const getDeclineReasonsCLAction = () => ({
    type: GET_DECLINE_REASONS_CL,
})

export const getDeclineReasonsCLActionSuccess = (payload) => ({
    type: GET_DECLINE_REASONS_CL_SUCCESS,
    payload
})

export const getCollectionCenterByLevelCLAction = () => ({
    type: GET_COLLECTION_CENTER_BY_LEVEL_CL,
})

export const getCollectionCenterByLevelCLActionSuccess = (payload) => ({
    type: GET_COLLECTION_CENTER_BY_LEVEL_CL_SUCCESS,
    payload
})
export const getGeolocationsActionSuccess = (payload) => ({
    type: GET_GEOLOCATIONS_SUCCESS,
    payload
})

export const resetScreeningColonRettoStateAction = () => ({
    type: RESET_SCREENING_COLON_RETTO_STATE,
})